import { translate } from 'react-translate'
import SerialNumber from './SerialNumber'

export default translate('FormUploadDevices')(SerialNumber)
